module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "table-of-content grid grid__dot-cols"
  }, 'div', _vm.cmsEditHelperAttrs, false), [_c('ul', {
    staticClass: "grid--row table-of-content--items u-reset"
  }, _vm._l((_vm.content.table_of_contents), function(page, pageIdx) {
    return _c('li', {
      staticClass: "grid--col table-of-content--item"
    }, [_c('div', {
      staticClass: "table-of-content--link-wrap"
    }, [_c('router-link', {
      staticClass: "u-reset table-of-content--link",
      class: _vm.bemAdd(page.theme || 'neutral', 'link'),
      attrs: {
        "to": page.path
      }
    }, [_c('div', {
      staticClass: "table-of-content--link-row"
    }, [_c('div', {
      staticClass: "table-of-content--link-arrow-col table-of-content--link-arrow-col__placeholder"
    }), _vm._v(" "), _c('div', {
      staticClass: "table-of-content--link-col"
    }, [_c('div', {
      staticClass: "table-of-content--link-content"
    }, [_c('h2', {
      staticClass: "u-reset u-reset__h1 table-of-content--title",
      domProps: {
        "innerHTML": _vm._s(page.title)
      }
    }), _vm._v(" "), (page.lead) ? _c('p', {
      staticClass: "table-of-content--lead",
      domProps: {
        "textContent": _vm._s(page.lead)
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "table-of-content--link-arrow-col"
    }, [_c('div', {
      staticClass: "table-of-content--link-arrow"
    }, [_c('div', {
      staticClass: "table-of-content--link-bg"
    }), _vm._v(" "), _c('cmp-icon', {
      staticClass: "table-of-content--link-icon table-of-content--link-icon__big",
      attrs: {
        "symbol": "chevron_big",
        "size": "large"
      }
    }), _vm._v(" "), _c('cmp-icon', {
      staticClass: "table-of-content--link-icon table-of-content--link-icon__small",
      attrs: {
        "symbol": "chevron_right",
        "size": "x-small"
      }
    })], 1)])])])], 1)])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-94b5b2ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94b5b2ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/table-of-content/index.vue
// module id = 570
// module chunks = 7